export function readContextBinding(optionValues, configuration) {
  const binding = optionValues?.context
    ?? configuration?.options?.context
    ?? configuration?.context
    ?? null;
  const name = binding?.entityContext;
  return {
    name: typeof name === "string" && name ? name : null,
    entityType: binding?.entityType ?? "",
  };
}

export function resolveStoryIdForContext(name, { scopedProvidedContexts, pageEntities, entityId } = {}) {
  if (entityId !== undefined && entityId !== null && entityId !== 0 && entityId !== "0") {
    return entityId;
  }
  if (!name) {
    return 0;
  }
  const scoped = typeof scopedProvidedContexts === "function" ? scopedProvidedContexts() : scopedProvidedContexts;
  const fromScope = scoped?.[name]?.entityPkUrlVars?.id ?? scoped?.[name]?.pk?.id;
  if (fromScope) {
    return Number(fromScope) || fromScope;
  }
  const pages = typeof pageEntities === "function" ? pageEntities() : pageEntities;
  const fromPage = pages?.[name];
  if (fromPage) {
    return Number(fromPage) || fromPage;
  }
  return 0;
}

export function isStoryTypedBinding(entityType) {
  return /(^|\.)Story$/i.test(String(entityType || ""));
}

// Whether the exclusivity badge is PRESENT. Presence is a property of the
// CONTENT — an exclusive story is exclusive whether or not this viewer has paid
// — so it follows isExclusive, not isLocked. Gating presence on isLocked
// (per-viewer entitlement) hid the badge from precisely the people who author it
// and from every paying subscriber: on dest 124 the "mobility" card is
// isExclusive:1 / isLocked:false for its own owner, so the lock never appeared.
//
// This deliberately reverses issue #176 part 4. isLocked still governs the
// content PAYWALL — an entitled subscriber sees a badge saying "this is
// premium", not a wall. Only presence moved.
export function passesExclusivePresenceGate({ isStoryGatedEmbed, editMode, isPreviewMode, story } = {}) {
  if (!isStoryGatedEmbed) {
    return true;
  }
  if (editMode || isPreviewMode) {
    return true;
  }
  return Boolean(story?.isExclusive ?? story?.exclusive);
}
